import { Outlet, useRouteError } from "react-router-dom";
import "./app.css";

console.log('Loading root component...');

export default function App() {
  console.log('Rendering App component...');
  return (
    <div className="min-h-screen bg-black text-white">
      <Outlet />
    </div>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();
  console.error('Route Error:', error);
  console.error('Error details:', {
    message: error instanceof Error ? error.message : 'Unknown error',
    stack: error instanceof Error ? error.stack : undefined,
    type: typeof error,
    error: error
  });

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <h1 className="text-4xl font-bold mb-4">Error!</h1>
      <p className="text-lg mb-4">Something went wrong. Please try refreshing the page.</p>
      <pre className="bg-gray-800 p-4 rounded overflow-auto mb-4">
        <code>{JSON.stringify(error, null, 2)}</code>
      </pre>
      <button 
        onClick={() => window.location.reload()} 
        className="bg-white text-black px-4 py-2 rounded hover:bg-gray-200"
      >
        Refresh Page
      </button>
    </div>
  );
}
